import { sampleRate } from "./sample-rate"

export type SrtCue = {
    start: number
    lines: string[]
}

const timecodeMs = (timecode: string) => {
    const [hours, minutes, seconds] = timecode.split(":")
    const [whole, fraction = "0"] = seconds.split(/[,.]/)
    return (
        Number(hours) * 3600000 +
        Number(minutes) * 60000 +
        Number(whole) * 1000 +
        Number(fraction.padEnd(3, "0"))
    )
}

export const parseSrtCues = (text: string) => {
    const cues: SrtCue[] = []
    let current: SrtCue | undefined
    for (const line of text.split(/\r?\n/)) {
        const arrow = line.indexOf(" --> ")
        if (arrow !== -1) {
            current = { start: timecodeMs(line.slice(0, arrow)), lines: [] }
            cues.push(current)
        } else if (current !== undefined && line.trim() !== "" && !/^\d+$/.test(line)) {
            current.lines.push(line)
        }
    }
    return cues
}

export const srtSampleRate = (cues: SrtCue[]) => sampleRate(cues.map((cue) => cue.start))
